export const MINIMUM_CHARGE_IN_CENTS = 50;
export const MAXIMUM_CHARGE_IN_CENTS = 1000000;
export const REQUEST_PAYMENT_VIDEO_URL =
  'https://www.youtube.com/embed/_50TcxEcuWY?si=fvFtymWw4LIM9_4i';
